import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Form, Col } from 'react-bootstrap';

import {
	COORDENADA_DMS_MASK_MAX_LENGTH,
	formatCoordenadaDmsMask,
} from '../../../util/cadernoLPMA/coordenadaDmsMask';

type Props = {
	name: string;
	control: Control<any>;
	label: string;
	md?: number;
	placeholder?: string;
};

const DEFAULT_PLACEHOLDER = 'Ex.: S 15° 31\' 10.11"';

export default function CoordenadaDmsField({
	name,
	control,
	label,
	md = 6,
	placeholder = DEFAULT_PLACEHOLDER,
}: Props) {
	return (
		<Controller
			name={name}
			control={control}
			render={({ onChange, value, ref }) => {
				const displayValue = formatCoordenadaDmsMask(String(value ?? ''));
				return (
					<Form.Group as={Col} md={md}>
						<Form.Label>{label}</Form.Label>
						<Form.Control
							ref={ref}
							value={displayValue}
							onChange={(e) => onChange(formatCoordenadaDmsMask(e.target.value))}
							placeholder={placeholder}
							maxLength={COORDENADA_DMS_MASK_MAX_LENGTH}
							inputMode="decimal"
							autoComplete="off"
						/>
					</Form.Group>
				);
			}}
		/>
	);
}
